import { Component, OnInit } from '@angular/core';
import { ConstanteUri } from '../constants/constante-uri';
import { ConstantePage } from '../constants/constante-page';
import { TagWaService } from '../services/tag-wa.service';
import { CnafUserService } from '@cnaf/ng-cnaf-commons';
import { PageFinModel } from './../03-fin/models/pagefin.model';
import { DroitSimulationModel } from './models/droitsimulation.model';

@Component({
  selector: 'app-fin',
  templateUrl: './fin.component.html'
})
export class FinComponent implements OnInit {

  pageName = ConstantePage.STATS_PAGE_RESULTAT_NON_DROIT;
  chapter3Page = ConstantePage.STATS_CHAPTER3_PAGE_RESULTAT;

  nombreEnfantMoinsXXansAvecRevenusSuperieur: number;
  seuilAge: number;
  codePostal : number; 
  montantDroit : number; 
  possedeDesDroits = false;

  pagePrecedente = ConstantePage.STATS_PAGE_DECLARATION;
  sessionPagePrecedente: string;

  droitSimulationModel: DroitSimulationModel;
  pageFinModel: PageFinModel;

  /**
   * Constructeur du composant 
   * @param cnafUserService 
   * @param tagWaService 
   */
  constructor(    
    private readonly cnafUserService: CnafUserService,
    private readonly tagWaService: TagWaService) {}

  /**
  * ngOnInit
  */
  ngOnInit() {
    // Récupérer les informations de la page de Fin sotckées en session
    this.sessionPagePrecedente = sessionStorage.getItem("pageFinModel");

    const jsonPagePrecedente = JSON.parse(this.sessionPagePrecedente);    
    if (jsonPagePrecedente!=null){
      this.seuilAge = jsonPagePrecedente.seuilAge;
      this.nombreEnfantMoinsXXansAvecRevenusSuperieur = jsonPagePrecedente.nombreEnfantMoinsXXansAvecRevenusSuperieur;
      this.codePostal = jsonPagePrecedente.codePostal;
      this.montantDroit = jsonPagePrecedente.montantDroit;
      this.possedeDesDroits = jsonPagePrecedente.possedeDesDroits;      
    }
    
    // Taguer la page
    this.envoyerTagPageFin();
  }

  /**
   * gestion de l'envoi du tag de la page (uniquement au retour du service simuler)
   */
  envoyerTagPageFin() : void  {
    // Si l'usager à un droit on change le nom de la page 
    if (this.possedeDesDroits) {
      this.pageName = ConstantePage.STATS_PAGE_RESULTAT_DROIT;
    }

    // On tague la page pour le WA
    this.tagWaService.tagPage(this.pageName, this.chapter3Page);
  }

  /**
   * Click Suivant
   */
  clickSuivant() {

    const codeOrga = this.cnafUserService.codeOrga;
    const matricule = this.cnafUserService.matricule;
    const dateEnvCaffr = this.cnafUserService.dateEnvCaffr;

    let url = ConstanteUri.URL_REDIRECT_EXIT;
    // si pas date d'environnement alors on ne fait rien
    if (dateEnvCaffr !== undefined) {
      if (matricule !== undefined && matricule !== '' && codeOrga !== undefined && codeOrga !== '' ) {
        if (this.codePostal >=97600 && this.codePostal <= 97699) {
          url = ConstanteUri.URL_REDIRECT_MAYOTTE;              
        }
        else {
          url = ConstanteUri.URL_REDIRECT_ALLOC;
        }
      }  
    }
    console.log('click sur faire la demande', url);
    // Pas de atinternet dans ce cas comme dans l'ancien simulateur
    window.location.assign(url);
  }

}
